import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { memo } from 'react';
import { NavSectionHorizontal } from 'src/components/dashboard/nav-section';
import { NavListProps } from 'src/components/dashboard/nav-section/type';
import { HEADER } from 'src/config';

const RootStyle = styled('div')(({ theme }) => ({
  transition: theme.transitions.create('top', {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
  position: 'fixed',
  zIndex: theme.zIndex.appBar,
  padding: theme.spacing(1, 0),
  top: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
  backgroundColor: theme.palette.background.default,
}));

type Props = {
  navConfig: {
    subheader: string;
    items: NavListProps[];
  }[];
};

function NavbarHorizontal({ navConfig }: Props) {
  return (
    <RootStyle>
      <Container maxWidth={false}>
        <NavSectionHorizontal navConfig={navConfig} />
      </Container>
    </RootStyle>
  );
}

export default memo(NavbarHorizontal);
